import { render } from "./Wholesale.vue?vue&type=template&id=b0e87450&scoped=true"
import script from "./Wholesale.vue?vue&type=script&lang=js"
export * from "./Wholesale.vue?vue&type=script&lang=js"

import "./Wholesale.vue?vue&type=style&index=0&id=b0e87450&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e87450"]])

export default __exports__